/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { BlurredImageProps, BlurredImage } from "@components/elements";
import { css } from "@panda/css";

const styles = css({
	position: "absolute",
	pointerEvents: "none",
	inset: 0,
	mdDown: {
		top: "auto",
		height: "auto",
		aspectRatio: "16 / 9",
		transformOrigin: "center",
	},
	smDown: {
		transform: "scale(0.7)",
		transformOrigin: "center",
	},
});

export const HeroAlphaBlurredImage = (props: BlurredImageProps): React.JSX.Element => {
	return (
		<div className={styles}>
			<BlurredImage {...props} disableAutoplay={!props.syncVideoRef && !props.sourceElement} />
		</div>
	);
};
